export default __webpack_public_path__ + "static/media/appendix2.4fe6bf30.jpg";